import axios from "axios";
import {Base_URL} from "../url"

export const fetchCurrencies = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CurrencyMaster/GetAllCurrencies`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching currency data!";
  }
};

export const downloadCurrenciesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CurrencyMaster/DownloadCurrenciesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading currency data!";
  }
};